import routeName from '../constant';

const routes = [
    {
        path: 'policy-paid-up',
        name: routeName.POLICY_PAID_UP,
        component: () => import('@/views/aplCatl640and631/C1/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '保單繳清', leaveAlert: true, code: 'C1', unableBack: true },
    }];

export default routes;
